import { useContext } from "react";
import { AllTableFiltersContext, AreFiltersDifferentFromDefaultContext as AreTableFiltersDifferentFromDefaultContext, GetSelectFilterContext, GetTableFilterContext, SetAllTableFiltersContext, SetTableFilterContext } from "../context";

export const useAllTableFilters = () => useContext(AllTableFiltersContext)!;
export const useGetTableFilter = () => useContext(GetTableFilterContext)!;
export const useGetSelectFilter = () => useContext(GetSelectFilterContext)!;
export const useSetTableFilter = () => useContext(SetTableFilterContext)!;
export const useSetAllTableFilters = () => useContext(SetAllTableFiltersContext)!;
export const useAreTableFiltersDifferentFromDefault = () => useContext(AreTableFiltersDifferentFromDefaultContext)!;